module.exports = "<h1 mat-dialog-title>Delink device from license?</h1>\n<div mat-dialog-content>\n<div mat-dialog-actions>\n  <button mat-button (click)=\"onNoClick()\">No</button>\n  <button mat-button mat-dialog-close=\"yes\" cdkFocusInitial>Yes</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/delink-device-dialog/delink-device-dialog.component.html
// module id = ./src/app/delink-device-dialog/delink-device-dialog.component.html
// module chunks = main